export default "__VITE_ASSET__DiFBF8d2__"